import { NgModule, Optional, SkipSelf } from '@angular/core';
import { APP_INITIALIZERS } from './initializers';
import { INTERCEPTORS } from './interceptors';

/**
 * Add here all modules, components, functionalities, services, IPC etc... that are load or used once in an Angular application.
 */

@NgModule({
	providers: [APP_INITIALIZERS, INTERCEPTORS],
})
export class CoreModule {
	// Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
	constructor(@Optional() @SkipSelf() coreModule: CoreModule) {
		if (coreModule) {
			throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
		}
	}
}
